module.exports = __webpack_public_path__ + "img/BusCardBG.47341c08.jpeg";